var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.352951,
    y: 0.5,
    width: 72,
    height: 72,
    rx: 12,
    fill: "#00C2D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7744 22.1919C51.8069 23.2244 51.8069 24.8869 50.7744 25.9019L43.9669 32.7094L47.6769 48.7919L45.2094 51.2769L38.4194 38.2744L31.5944 45.0994L32.2244 49.4219L30.3519 51.2769L27.2719 45.7119L21.6894 42.6144L23.5444 40.7244L27.9194 41.3719L34.6919 34.5994L21.6894 27.7569L24.1744 25.2894L40.2569 28.9994L47.0644 22.1919C48.0444 21.1769 49.7944 21.1769 50.7744 22.1919Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.852951,
    y: 1,
    width: 71,
    height: 71,
    rx: 11.5,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.2c19fb8f92bb2ea9ec5820eb97695617.svg";
export { ForwardRef as ReactComponent };